import React, { useContext, useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import Card from "../components/Card";
import Pagination from "../components/layout/Pagination";
import FiltriTest from '../components/FiltriTest'
import ProductContext from '../context/products/ProductContext'
import Spinner from '../components/layout/Spinner'
import { Helmet } from 'react-helmet';

function OilListTest1() {
    const { oils,
        loading,
        fetchOils,
        totalPages,
        setTotalPages,
        handlePageChange,
        currentPage,
        setCurrentPage } = useContext(ProductContext)

    const location = useLocation()


    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const manufacturer = queryParams.get('manufacturer') ?? '';
        const viscosities = queryParams.getAll('viscosity') ?? [];
        const sortBy = queryParams.get('sortBy') ?? '';
        const pageSize = queryParams.get('pageSize') ?? 8;
        const currentPage = queryParams.get('currentPage') ?? 1;
        const totalPages = queryParams.get('totalPages') ?? 1;
        setCurrentPage(currentPage)
        setTotalPages(totalPages)

        fetchOils(manufacturer, viscosities, sortBy, pageSize, currentPage)
    }, [location.search]);

    const queryParamsHelmet = new URLSearchParams(location.search);
    const manufacturerHelmet = new URLSearchParams(location.search).get('manufacturer') ?? '';
    const viscositiesHelmet = queryParamsHelmet.getAll('viscosity') ?? []; 


    const title = manufacturerHelmet
        ? `${manufacturerHelmet} Масло за Автомобили | ${manufacturerHelmet} maslo po najdobri ceni | ${manufacturerHelmet} ulje za avtomobili`
        : 'Автомобилски масла | Kupete maslo od najpoznatite brendovi';


    const description = manufacturerHelmet
        ? `Купете масло од брендот ${manufacturerHelmet} со различни вискозитети како 0W-20, 0W-30, 5W-30, 5W-40 и 10W-40 (${manufacturerHelmet} maslo) по најдобри цени. Погледнете ја нашата понуда на масла!`
        : `Пронајдете масла од најпознатите брендови како Motul, Shell, Mobil, Castrol и многу други. Вискозитети: 0W-20, 0W-30, 5W-30, 5W-40, 10W-40. Kupete maslo po najdobri ceni!`;

    const keywords = manufacturerHelmet
        ? `${manufacturerHelmet}, ${manufacturerHelmet} масло, масла, уље, автомобилско масло, ${viscositiesHelmet ? viscositiesHelmet.join(', ') : '0W-20, 0W-30, 5W-30, 5W-40, 10W-40'}, Motul, Shell, Mobil, Castrol, Fuchs, Total, Mannol, Elf, Valvoline`
        : 'Motul масло, Shell масло, Mobil масло, Castrol масло, Fuchs масло, Total масло, Elf масло, maslo, Mannol масло, Valvoline масло, 0W-20, 0W-30, 5W-30, 5W-40, 10W-40, масла за автомобили, уље за кола';


    if (loading) {
        return <Spinner />
    }

    return (
        <>
            <Helmet>
                <title>{title}</title>

                <meta name="description" content={description} />

                <meta name="keywords" content={keywords} />
            </Helmet>

            <div className='flex flex-col justify-start items-center'>
                <div>
                    <h1 className='text-4xl font-bold mb-8 text-center'>Масло за Автомобили</h1>
                </div>
                <FiltriTest />

                {oils.length > 0 && (
                    <><div>Тековна страна: {currentPage}</div>
                        <Pagination
                            totalPages={totalPages}
                            currentPage={currentPage}
                            onPageChange={handlePageChange}
                        /></>
                )}

                <div
                    className={`grid gap-4 mt-[5%] text-xl ${oils.length === 1 ? 'grid-cols-1 justify-center' : oils.length === 2 ? 'grid-cols-1 md:grid-cols-2 justify-center' : 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4'
                        }`}
                >
                    {oils.length === 0 ? (
                        <p>Нема масло за прикажување според избраните критериуми.</p>
                    ) : (
                        oils.map((oil) => (
                            <Card key={oil.id} item={oil} allFilters={false} className='mr-4 mb-4' />
                        ))
                    )}
                </div>
                {oils.length > 0 && (
                    <><div>Тековна страна: {currentPage}</div>
                        <Pagination
                            totalPages={totalPages}
                            currentPage={currentPage}
                            onPageChange={handlePageChange}
                        /></>
                )}

            </div>
        </>
    )
}

export default OilListTest1
